<template>
  <div class="download mb30">
    <el-row :gutter="60" class="mt20">
      <el-col :span="12">
        <!-- <h3 class="title"><i class="fa fa-cloud-download" /> RNA-seq transcriptomic data (7 files)</h3> -->
        <h3 class="title">RNA-seq transcriptomic data (6 files)</h3>
        <el-divider></el-divider>
        <el-table
          class="mt20"
          :data="tbData1"
          border
          style="width: 100%">
          <el-table-column
            prop="filename"
            label="File name">
          </el-table-column>
          <el-table-column
            prop="size"
            label="Size">
          </el-table-column>
        </el-table>
        <!-- <h3 class="mt30 title"><i class="fa fa-cloud-download" /> MS-based proteomic data (7 files)</h3> -->
        <el-button class="mt10" type="primary" @click="handleDownLink">Apply for download</el-button>
      </el-col>
      <el-col :span="12">
        <h3 class="title">MS-based proteomic data (6 files)</h3>
        <el-divider></el-divider>
        <el-table
          class="mt20"
          :data="tbData2"
          border
          style="width: 100%">
          <el-table-column
            prop="filename"
            label="File name">
          </el-table-column>
          <el-table-column
            prop="size"
            label="Size">
          </el-table-column>
        </el-table>
      </el-col>
      <!-- <el-col :span="12" class="outer">
        <iframe
          ref="myIframe"
          :src="iframeSrc"
          style="border:none; width:100%; height:640px"
          frameborder="0"
          sandbox="allow-same-origin allow-scripts"
        ></iframe>
      </el-col> -->
    </el-row>
  </div>
</template>

<script>
  import {  } from '@/api'
  export default {
    name: 'download',
    data() {
      return {
        tbData1: [{
          filename: 'S4_mRNA.h5ad',
          size: '10.7 MB'
        }, {
          filename: 'S5_mRNA.h5ad',
          size: '14.3 MB'
        }, {
          filename: 'S6_mRNA.h5ad',
          size: '15.3 MB'
        }, {
          filename: 'Egg_mRNA.h5ad',
          size: '13.7 MB'
        }, {
          filename: 'EZ_mRNA.h5ad',
          size: '13.7 MB'
        }, {
          filename: 'LZ_mRNA.h5ad',
          size: '14.7 MB'
        }],
        tbData2: [{
          filename: 'S4_Protein.h5ad',
          size: '2.7 MB'
        }, {
          filename: 'S5_Protein.h5ad',
          size: '3.1 MB'
        }, {
          filename: 'S6_Protein.h5ad',
          size: '3.3 MB'
        }, {
          filename: 'Egg_Protein.h5ad',
          size: '2.7 MB'
        }, {
          filename: 'EZ_Protein.h5ad',
          size: '4.1 MB'
        }, {
          filename: 'LZ_Protein.h5ad',
          size: '3.3 MB'
        }],
        iframeSrc: 'https://xenostar.ncpsb.org.cn/clustrmap.html'
      }
    },
    mounted() {
      // this.loadClustrMaps()
      // this.$nextTick(() => {
      //   this.loadClustrMaps()
      // })
    },
    created() {
      
    },
    methods: {
      loadClustrMaps() {
        const script = document.createElement("script");
        script.src = "//clustrmaps.com/globe.js?d=AfJaTaS96exh5MEGs5gBDkZc6rulGFKgNuKopm1_fCU";
        script.async = true;
        script.defer = true;
        script.id = 'clstr_globe'
        this.$refs["clustrmaps-container"].appendChild(script);
      },
      handleDownLink() {
        this.$router.push({path: '/contacts'})
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .download {
    background: #ffffff;
    padding: 20px;
    width: 80%;
    margin: auto;
    .title {
      color: #17754a;
    }
    .outer {
      display: flex;
      // justify-content: center; /* 水平居中 */
      align-items: center;    /* 垂直居中 */
      padding: 30px;
      // margin-top: 80px;
    }
  }
  .clustrmaps-scaled {
    transform: scale(0.8); /* 缩小到 80% */
    transform-origin: top left;
    width: 80%; /* 补偿缩放后的容器大小（100% / 0.8 = 125%） */
    height: 80%;
  }
</style>
